import cn from 'classnames';
import React, { useEffect, useRef } from 'react';
import { Swiper } from 'swiper';

type TClaimsGuideCarouselProgressProps = {
  swiperInstance?: Swiper;
};

export const ClaimsGuideCarouselProgress = ({
  swiperInstance,
}: TClaimsGuideCarouselProgressProps) => {
  if (!swiperInstance) {
    return null;
  }

  return (
    <div className="flex gap-2">
      {Array.from({ length: swiperInstance.slides.length }).map((_, indicatorIndex) => {
        if (swiperInstance.activeIndex === indicatorIndex && swiperInstance.autoplay.running) {
          return <AnimatedIndicator key={indicatorIndex} swiperInstance={swiperInstance} />;
        }

        return (
          <div
            key={indicatorIndex}
            className={cn('rounded-sm w-[24px] h-[4px] bg-white', {
              'opacity-50': swiperInstance.activeIndex < indicatorIndex,
            })}
          />
        );
      })}
    </div>
  );
};

type TAnimatedIndicatorProps = {
  swiperInstance: Swiper;
};

const AnimatedIndicator = ({ swiperInstance }: TAnimatedIndicatorProps) => {
  const progressBarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleAutoplayTimeLeft = (_: unknown, __: unknown, progress: number) => {
      progressBarRef.current?.style.setProperty('width', `${24 * (1 - progress)}px`);
    };

    swiperInstance.on('autoplayTimeLeft', handleAutoplayTimeLeft);

    return () => {
      swiperInstance.off('autoplayTimeLeft', handleAutoplayTimeLeft);
    };
  }, [swiperInstance]);

  return (
    <div className="relative overflow-hidden rounded-sm w-[24px] h-[4px]">
      <div className="absolute inset-0 bg-white opacity-50" />
      <div ref={progressBarRef} className="absolute top-0 bottom-0 left-0 bg-white" />
    </div>
  );
};
